import React from 'react'
import './GeneralStyle.css'
import { InputField, ToggleSwitch } from '@enamelai/design-system'
import MessagingAutoReplyEditor from '../../Messaging/MessagingAutoReplyEditor.component'
import loginLogo from '@assets/images/login/login-logo.svg'
import GoogleConnection from '../GoogleConnection/GoogleConnection.component'
import { type EmailSettingsForm } from '../useEmail'
import { Icon as InfoIcon } from '@enamelai/design-system/icons/Info'

type GeneralTabProps = {
  data: EmailSettingsForm
  onChange: <K extends keyof EmailSettingsForm>(
    key: K,
    value: EmailSettingsForm[K],
  ) => void
  onGoogleMailboxConnected?: () => Promise<void>
  onGoogleMailboxDisconnected?: () => Promise<void>
}

const GeneralTab = ({
  data,
  onChange,
  onGoogleMailboxConnected,
  onGoogleMailboxDisconnected,
}: GeneralTabProps): React.ReactElement => {
  return (
    <div className="scp-email-general">
      <GoogleConnection
        onMailboxConnected={onGoogleMailboxConnected}
        onMailboxDisconnected={onGoogleMailboxDisconnected}
      />

      <div className="scp-email-general-field">
        <span className="scp-pm-label">Profile picture</span>
        <div className="scp-email-general-profile-row">
          <div className="scp-email-general-avatar">
            {data.profile_picture_url ? (
              <img src={data.profile_picture_url} alt="Profile" />
            ) : (
              <img src={loginLogo} alt="Clinic logo" />
            )}
          </div>
          <span className="scp-email-general-profile-hint">
            Synced from your connected Google account.
          </span>
        </div>
      </div>

      <div className="scp-email-general-field-row">
        <div className="scp-email-general-field">
          <InputField
            variant="text"
            label="Display name"
            fullWidth
            value={data.display_name}
            onChange={(e) => onChange('display_name', e.target.value)}
          />
        </div>
      </div>

      <div className="scp-email-general-section-header">
        <span className="scp-email-general-section-title">
          Add signature
          <span
            className="ds-section-card__icon-button"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Signature appended to outgoing emails when enabled."
          >
            <InfoIcon aria-hidden="true" />
          </span>
        </span>
        <ToggleSwitch
          id="email-signature-enabled"
          aria-label="Add signature"
          checked={data.signature_enabled}
          onChange={(checked) => onChange('signature_enabled', checked)}
        />
      </div>
      <div className="scp-email-general-signature-editor">
        <MessagingAutoReplyEditor
          value={data.signature}
          disabled={!data.signature_enabled}
          editorHeight="140px"
          onChange={(next) => onChange('signature', next)}
        />
      </div>
    </div>
  )
}

export default GeneralTab
